module.exports = __webpack_public_path__ + "img/agendaurbana.8b29c7b7.png";